import React from 'react';
import withErrorHandler from './ErrorHandler';
import {
    Icon,
} from '@bosch/bt-ui'
import CheckmarkIcon from '../../icons/checkmark-bold.svg'
import './ServiceStatesIndicator.css'

const ServiceStatesIndicator = (props) => {
    const {
        isChecked
	} = props;
    return (
    <div className="service-state-checkbox">
        <input
            type="checkbox"
            checked={isChecked}
        />
        <label>
        {
            isChecked && <Icon
                icon={CheckmarkIcon}
            />
        }
       </label>
    </div>
    );
}

export default withErrorHandler(ServiceStatesIndicator);